import * as React from "react";
import { KeyboardEvent } from "react";
import { IContactItemProps } from "./~types/ContactItemProps";
import ContactMessengers from "./contact-messengers/ContactMessengers";

import "./ContactItem.css";
import { getDateTime } from "src/app/shared/helpers/date-helper/DateFormats";
import { useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import ContactIcon from "@mui/icons-material/AccountCircle";
import { GET_FILE_BY_ID_API_ROUTE } from "src/app/chats-panel/~api/apiRoutes";
import { ChannelType } from "../../../~store/models/ChannelType";

const ContactItem = (props: IContactItemProps) => {
  const navigate = useNavigate();

  const { contact } = props;

  const userInStorage = sessionStorage.getItem("user");
  const customerId =
    userInStorage === null
      ? ""
      : JSON.parse(userInStorage.toString()).customerId;
  const avatarLink =
    contact.avatarId === null
      ? ""
      : GET_FILE_BY_ID_API_ROUTE +
        contact.avatarId +
        "&customerId=" +
        customerId;

  const navigateToContact = () => {
    let selection = window?.getSelection()?.toString();
    if (!selection || selection.length <= 0) {
      navigate("/contacts/edit-contact/" + contact.contactId)
    }
  };

  const handleKeyUp = (e: KeyboardEvent<HTMLTableRowElement>) => {
    if (e.key === "Enter") {
      navigateToContact();
    }
  };

  return (
    <React.Fragment>
      <tr
        onClick={navigateToContact}
        className="contact-item__table-row"
        tabIndex={0}
        onKeyUp={handleKeyUp} 
      >
        <td className="contact-item__contact-info-cell">
          <div className="contact-item__contact-info-container">
            <Avatar className="contact-item__contact-avatar" src={avatarLink}>
              <ContactIcon style={{ color: "#26a69a" }} />
            </Avatar>
            <div className="contact-item__contact-info">
              <div className="contact-item__contact-name">
                {(`${contact.lastName ?? ''} ${contact.firstName ?? ''}`).trim() || contact.chatName}
              </div>
              <div className="contact-item__contact-phone">
                {contact.phone !== null && contact.phone.length > 0
                  ? "+" + contact.phone
                  : ""}
              </div>
            </div>
          </div>
        </td>
        <td className="contact-item__messengers">
          <ContactMessengers
            messengers={contact.messengers}
            isNeedDetach={false}
          />
        </td>
        <td className="contact-item__creation-date">
          {getDateTime(contact.createdOn)
            ?.split(",")
            ?.map((d, ind) => (
              <span key={ind}>{d}</span>
            ))}
        </td>
        <td className="contact-item__chats-count">{contact.chatsCount}</td>
      </tr>
    </React.Fragment>
  );
};

export default ContactItem;
